@import "~/styles/variables";

/*
 * NOTE:
 * These need fully reset styles for now thanks to our global v1 styles.
 * I've used @csstools/normalize.css as a reference for this,
 * as that's what we'll use for our CSS Normalize eventually.
 * See: https://create-react-app.dev/docs/adding-css-reset/
 * See: https://github.com/csstools/postcss-normalize
 * See: https://github.com/csstools/normalize.css/blob/master/normalize.css
 */

.h1,
.h2,
.h3,
.h4 {
  line-height: 1.15; // From @csstools/normalize.css
  margin: 0;

  &.serif {
    @include font-family("serif");
  }

  &.reverse {
    @include font-color("white");
  }

  @each $size, $val in $space-sizes {
    &.stack_#{$size} {
      @include stack($size);
    }
  }
}

.h1 {
  @include font-family("sans");
  @include font-size("xl");
  @include font-weight("regular");
  color: $font-color;
}

.h2 {
  @include font-family("sans");
  @include font-size("l");
  @include font-weight("semibold");
  color: $font-color;
}

.h3 {
  @include font-family("sans");
  @include font-size("m");
  @include font-weight("semibold");
  color: $font-color;
}

.h4 {
  @include font-family("sans");
  @include font-size("xs");
  @include font-weight("bold");
  color: $font-color;
  text-transform: uppercase;
}
